$(() => {
  if ($("[data-parallax]").length === 0) return
  if ($(window).width() >= 768) {
    /* global Rellax */
    // eslint-disable-next-line no-new
    new Rellax("[data-parallax]", {
      speed: 0,
      center: true,
    })
  }
})



// WEBPACK FOOTER //
// ./src/blocks/parallax/parallax.js